import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmailValidator {

  /**
   * Checks if the input string 'email' is a valid e-mail address
   * @param email
   * @returns true or false
   */
  public static isValidEmail(email: String) {
    if (email == null || email.trim().length === 0) return false;

    //Extract the email by Regex
    let emailRgx = email.trim().match(/^[a-z0-9+._-]+@[a-z0-9]+(\.[a-z]+)+$/ig);

    if (emailRgx == null ) return false;
    return true;
  }
}

